export class AutocompleteValuesDto {
    Distributors: string[] = [];
    Countries: string[] = [];
    LibraryNames: string[] = [];
    DeviceUse: string[] = [];
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/licencing/autocomplete-values.dto.ts